<template>
    <div class="col-lg-9">
        <div class="card">
            <div class="card-body">
                <div class="p-4 rounded-0">
                    <div v-if="!fail">

                        <h3 v-if="!loading" class="text-5 text-center mb-5">Stripe Payment</h3>
                        <h3 v-else class="text-5 text-center mb-5">Checking Payment ... </h3>
                        <div class="text-center text-primary text-20 line-height-07 mb-5 d-flex justify-content-center align-items-center">
                            <div class="loader"></div>
                        </div>

                        <p v-if="!loading" class="text-center text-primary text-8 line-height-07 mb-5">
                            {{ this.countDown }}
                        </p>
                        <p class="text-center text-4 mb-5">Your transaction is pending and will be processed after payment confirmation.</p>
                        <p v-if="!loading" class="text-center">If you have completed payment  <br> click below.</p>
                        <div class="form-group">
                            <button @click="submit" :class="['btn btn-primary btn-block' , loading ? 'btn-loading' : '']">Confirm Payment</button>
                        </div>
                    </div>

                    <div v-else>

                        <h3 v-if="" class="text-5 text-center mb-5">Stripe Payment</h3>
                        <div class="text-center text-primary text-20 line-height-07 mb-5 d-flex justify-content-center align-items-center">
                            <i class="fas fa fa-times-circle"></i>
                        </div>
                        <p class="text-center text-4 mb-5">Your payment Failed to go through <br> kindly retry payment using the link below.</p>

                        <div class="form-group">
                            <router-link to="/" :class="['btn btn-primary btn-block' , loading ? 'btn-loading' : '']">Retry Payment</router-link>
                        </div>

                        <div class="form-group">
                            <button @click.prevent="submit" :class="['btn btn-primary btn-block' , loading ? 'btn-loading' : '']">Refresh</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ecocash",
        data()
        {
            return {
                loading: false,
                done: false,
                fail: false,
                countDown : 5,
                ref : this.$route.query.ref
            };

        },
        methods : {
            submit()
            {
                if (this.loading || this.done)
                {
                    return;
                }

                this.loading = true;
                this.countDown = 0;

                // Check Payment

                window.axios['post'](`${window.location.origin}/stripe/batch/check` , {
                    ref : this.ref
                }).then((response) => {

                    if (response.data.success)
                    {
                        if (response.data.body.pending)
                        {
                            this.countDown = 30;
                            this.startCountDown();
                            return;
                        }

                        this.done = true;
                        this.$router.push(`/business/view?ref=${this.ref}`);

                    } else {
                        this.fail =  true;
                    }

                }).finally(() => {
                    this.loading = false;
                });
            },
            startCountDown()
            {
                if(this.countDown > 0)
                {
                    setTimeout(() => {
                        this.countDown -= 1;
                        this.startCountDown();
                    }, 1000);

                } else {
                    if (!this.loading)
                        this.submit();
                }
            },
        },

        mounted()
        {
            if (!localStorage.getItem('loadedOnce') || localStorage.getItem('loadedOnce') === "false") {
                window.location.reload();
                localStorage.setItem('loadedOnce', true);
            }
            this.startCountDown();
        }
    }
</script>

<style scoped>

</style>
